globalThis.initBtnLoading = function($els) {
  $els.click(function (e) {
    var $this = $(this);

    if(!$this.data('loading-text')) {
      $this.data('loading-text', '<i class="icon-spinner4 spinner position-left"></i> Veuillez patienter...')
    }

    $this.button('loading');
  });
}
